<template>
  <div v-if="showMessage"
       :class="[feedback.hasError ? 'app-alert-error' : 'app-alert-warning']"
       role="alert" aria-live="off"><!-- no feedback if user has opt-out -->
    <img v-if="feedback.hasError" src="@ridmv/web-themes/images/icons/exclamation-triangle-solid.svg" alt="">
    <img v-else src="@ridmv/web-themes/images/icons/paper-plane-solid.svg" alt="">
    <p tabindex="-1" ref="message" class="animate__animated animate__headShake" v-if="feedback.message">
      {{ feedback.message }}
    </p>
    <p tabindex="-1" ref="message" class="animate__animated animate__headShake" v-else>
      {{ this.message }}
    </p>
  </div>
</template>

<script>
import _ from 'underscore'
import { mapState } from 'vuex'
import NotificationFeedback from '@/assets/_systemFeedback'

export default {
  name: "NotificationStatus",
  props: {
    showMessage: {
      type: Boolean,
      required: false,
      default: false,     // prevent display on reload
    },
  },
  data() {
    return {
      feedback: {},
      inWorkTxnMessage:[],
      message:''
    };
  },
  computed: {
    ...mapState([
      'resNotificationSent',
    ]),
  },
  watch: {
    resNotificationSent() {
      this.setupMessage();
    }
  },
  mounted() {
    this.setupMessage();
  },
  methods: {
    getFeedback() {

      
      for(let i in this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartTransactions) {
                 if( this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartTransactions[i].transactionData.transactionStatus == "In Work")
                 {  
                  this.inWorkTxnMessage.push(this.$store.state.guestLogin.finalizationCart.finalizeCartResponse.transactionCart.cartTransactions[i].transactionData.transactionId)
                 }
       }      
       if(this.inWorkTxnMessage.length!==0)
        {
          this.message="Following Transaction(s) have failed. Transaction ID: " + this.inWorkTxnMessage.join(",",this.inWorkTxnMessage) + ". For more information, please contact the DMV at 401-462-4368. For transaction(s) completed successfully a confirmation text and / or e-mail has been sent to the information provided."
        }    
        else
        {
          this.message="Your transaction is completed successfully."
        }

      if (this.$store.state.guestLogin.resNotificationSent) {

        const smsError = _.find(NotificationFeedback, fbk => fbk.errorType === 'sms');
        const emailError = _.find(NotificationFeedback, fbk => fbk.errorType === 'email');
        const dblError = _.find(NotificationFeedback, fbk => fbk.errorType === 'both');
        let feedback =_.find(NotificationFeedback, fbk => fbk.errorType === 'none');
        
        if(this.inWorkTxnMessage.length!==0)
        {
           feedback=this.message      
        }
        else if (!this.$store.state.guestLogin.resNotificationSent.isSmsSentSuccessfully && !this.$store.state.guestLogin.resNotificationSent.isEmailSentSuccessfully) {
          feedback = dblError;
        } else if (!this.$store.state.guestLogin.resNotificationSent.isSmsSentSuccessfully) {
          feedback = smsError;
        } else if (!this.$store.state.guestLogin.resNotificationSent.isEmailSentSuccessfully) {
          feedback = emailError;
        } 
        return { hasError: !(feedback.errorType === 'none'), message: feedback.message };
      }
      return {};
    },
    setupMessage() {

      this.feedback = this.getFeedback();
      this.$nextTick(() => {
        if (this.$store.state.guestLogin.resNotificationSent && this.$store.state.guestLogin.resNotificationSent.isConsentProvided && this.$refs.message) {
          this.$refs.message.focus();
        }
      });
    }
  }
}
</script>
<style lang="scss" scoped>
@media print {
  div, img, p {
    display: none;
  }
}
</style>

